<template>
  <LcSelect
    v-bind="{ ...$attrs, ...selectProps, options }"
    v-model:value="modelValue"
    no-feedback
    no-teleport
    not-nullable
  />
</template>

<script lang="ts" setup>
import type { LcSelectOption, LcSelectProps } from '@lottocom/frontend-components'

import type { AddOn } from '#api/shared/@types/generated/backend/graphql-schema-types'
import type { LotterySelectedPerPlayAddOn } from '#product/app/stores/lottery'

export type PerPlayAddOnSelectorProps = Pick<LcSelectProps, 'ignoreOutsideClickOn' | 'label'> & {
  addOn: AddOn
  lotteryId: string
  value: LotterySelectedPerPlayAddOn
}

type PerPlayAddOnSelectorEmits = {
  (event: 'update:value', value: LotterySelectedPerPlayAddOn): void
}

const emit = defineEmits<PerPlayAddOnSelectorEmits>()
const { addOn, lotteryId, value, ...selectProps } = defineProps<PerPlayAddOnSelectorProps>()

const { getPerPlayTranslation } = useTranslations()

const modelValue = computed({
  get: () => value.value,
  set: (newValue) => {
    emit('update:value', { name: addOn.name, value: newValue })
  },
})
const options = computed(() => addOn.options.map(toOption) || [])

const toOption = (perPlayAddOn: string): LcSelectOption => ({
  label: getPerPlayTranslation(lotteryId, addOn.name, perPlayAddOn),
  value: perPlayAddOn,
})
</script>
